import { render, staticRenderFns } from "./CnDetail.vue?vue&type=template&id=ce379d88&scoped=true&"
import script from "./CnDetail.vue?vue&type=script&lang=js&"
export * from "./CnDetail.vue?vue&type=script&lang=js&"
import style0 from "./CnDetail.vue?vue&type=style&index=0&id=ce379d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce379d88",
  null
  
)

export default component.exports